export default "/assets/images/column-image5_1.png?e64a60e680511c49ad3a92edf901874c";